import ApiService from '../api.services';

const DeliveryService = {
    list: async function (records, page, search) {
        try {
            const response = await ApiService.get(`/api/deliveries?records=${records}&page=${page}&search=${search}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    listByCustomer: async function (customer) {
        try {
            const response = await ApiService.get(`/api/deliveries/customer/${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/deliveries/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data) {
        try {
            const response = await ApiService.post('/api/deliveries', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, data) {
        try {
            const response = await ApiService.put(`/api/deliveries/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/deliveries/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default DeliveryService;

export { DeliveryService };

